// QuoteStatusPDF.jsx
import React from "react";
import { View, Text } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

const statusColors = {
  pending: "#ffa500",
  accepted: "#1ba34d",
  refused: "#f11414ff",
  invoiced: "rgba(19, 30, 190, 1)",
  default: "#000",
};

const statusLabels = {
  pending: "quote.status.pending",
  accepted: "quote.status.accepted",
  refused: "quote.status.refused",
  invoiced: "quote.status.invoiced",
};

const QuoteStatusPDF = ({ status }) => {
  const { t } = useTranslation();

  const color = statusColors[status] || statusColors.default;
  const label = t(statusLabels[status]) || t(status);
  return (
    <View
      style={{
        marginTop: 10,
        padding: 6,
        borderRadius: 4,
        backgroundColor: "#f2f2f2",
        width: "auto",
        alignSelf: "flex-start",
      }}>
      <Text
        style={{
          fontSize: 12,
          color,
          fontWeight: "bold",
        }}>
        {t("quote.status")} : {label}
      </Text>
    </View>
  );
};

export default QuoteStatusPDF;
